export default {
    config: {
        shareUrl: {
            default: {
                baseUrl: 'https://max.ru/:share',
                params: {
                    text: 'url',
                },
            },
        },
    },

    popupDimensions: [800, 520],

    i18n: {
        az: 'MAX',
        be: 'MAX',
        en: 'MAX',
        hy: 'MAX',
        ka: 'MAX',
        kk: 'MAX',
        ro: 'MAX',
        ru: 'MAX',
        tr: 'MAX',
        tt: 'MAX',
        uk: 'MAX',
    },

    color: '#8539FF',
};
